export const acceptedImageFileExtensions = [".jpg", ".jpeg", ".png", ".webp"];

export const maxHeroImageSizeBytes = 25 * 1024 * 1024;
export const maxBodyImageSizeBytes = 10 * 1024 * 1024;

export const acceptedVideoFileExtensions = [".mp4", ".webm", ".ogv", ".mov"];

export const maxVideoFileSizeBytes = 1024 * 1024 * 1024;

const hasAcceptedExtension = (file: File, extensions: string[]): boolean =>
  extensions.some((extension) => file.name.toLowerCase().endsWith(extension));

export const isAcceptedImageFile = (file: File): boolean => hasAcceptedExtension(file, acceptedImageFileExtensions);

export const isAcceptedVideoFile = (file: File): boolean => hasAcceptedExtension(file, acceptedVideoFileExtensions);

export const getBodyImageRejectionReason = (file: File): string | undefined => {
  if (!isAcceptedImageFile(file)) {
    return `unsupported image format. Allowed: ${acceptedImageFileExtensions.join(", ")}`;
  }

  if (file.size > maxBodyImageSizeBytes) {
    return "the image is too large. Maximum size is 10 MB.";
  }

  return undefined;
};
